import './_sort.scss';
import component from './sort';

export default component;
